import { createSlice } from '@reduxjs/toolkit'

export const agentSlice = createSlice({
    name: 'agent',
    initialState: {
        userData: {
            firstName: '',
            lastName: '',
            email: '',
            timezone: '',
            agentId: '',
            teamId: '',
            defaultCalendar: null,
            numbers: '',
            admin:false,
            organization:'',
            permissions:[],
            organizationName:'',
            agentCode:null,
            beta:false,
            status: false,
            smartSelect: false,
            selectChoice: null,
        },
        phoneNumbers: [],
        textingNumbers: [],
        activeCalendar:false,
        logo:null,
        refreshLogin:false,
        recordingConsent: null,
        record_calls: null,
        record_side: null,
    },
    reducers: {
        /*setUserData(state, action) {
            state.userData = action.payload;
        },*/
        setUserData(state, action) {
            console.log('updated user data', {
                ...state.userData,
                ...action.payload
            })
            state.userData = {
                ...state.userData,
                ...action.payload
            };
        },
        setPhoneNumbers(state, action) {
            state.phoneNumbers = action.payload;
        },
        setLogo(state, action) {
            state.logo = action.payload;
        },
        setTextNumbers(state, action) {
            state.textingNumbers = action.payload;
        },
        setActiveCalendar(state, action) {
            state.activeCalendar = action.payload;
        },
        setScopes(state, action) {
            state.userData.permissions = action.payload;
        },
        setRefreshLogin(state, action) {
            state.refreshLogin = action.payload;
        },
        setRecordingConsent(state, action) {
            state.recordingConsent = action.payload.recording_consent;
            state.record_side = action.payload.record_side;
            state.record_calls = action.payload.record_calls == 1 ? true : false;
        },
    },
})

// Action creators are generated for each case reducer function
export const { setSelectChoice, setSmartSelect, setUserData, setPhoneNumbers, setActiveCalendar, setTextNumbers, setScopes, setLogo, setRefreshLogin,setRecordingConsent } = agentSlice.actions;

export default agentSlice.reducer
